import { SUPER_ADMIN_SET_SELECTED_USER_CCS } from '../types';

type SelectedUserCostCentersState = unknown[];

interface SelectedUserCostCentersAction {
  type: string;
  costCenters?: unknown[];
}

const initialState: SelectedUserCostCentersState = [];

const selectedUserCostCenters = (
  state: SelectedUserCostCentersState = initialState,
  action: SelectedUserCostCentersAction,
): SelectedUserCostCentersState => {
  switch (action.type) {
    case SUPER_ADMIN_SET_SELECTED_USER_CCS:
      return action.costCenters || state;
    default:
      return state;
  }
};

export default selectedUserCostCenters;
